import { z } from 'zod';
import { RACQUET_SPORT_IDS } from '../constants/racquetSports';

export const academySportFormSchema = z
  .object({
    sportId: z.enum(RACQUET_SPORT_IDS),
    customLabel: z.string().max(80).optional().nullable(),
    isPrimary: z.boolean().default(false),
    isActive: z.boolean().default(true),
  })
  .superRefine((data, ctx) => {
    if (data.sportId === 'other' && !data.customLabel?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Custom label is required for Other sport',
        path: ['customLabel'],
      });
    }
  });

export type AcademySportFormData = z.infer<typeof academySportFormSchema>;

export const updateAcademySportsSchema = z
  .object({
    academyId: z.string().uuid(),
    sports: z.array(academySportFormSchema).min(1).max(6),
  })
  .superRefine((data, ctx) => {
    const primary = data.sports.filter((s) => s.isPrimary);
    if (primary.length !== 1) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Exactly one primary sport is required',
        path: ['sports'],
      });
    }
    const ids = data.sports.map((s) => s.sportId);
    if (new Set(ids).size !== ids.length) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Duplicate sports are not allowed',
        path: ['sports'],
      });
    }
  });

export type UpdateAcademySportsPayload = z.infer<typeof updateAcademySportsSchema>;

export const coachSportQualificationSchema = z.object({
  academySportId: z.string().uuid(),
  level: z.enum(['assistant', 'certified', 'head', 'pro']).default('certified'),
  certifiedAt: z.string().optional().nullable(),
  notes: z.string().max(500).optional().nullable(),
});

export type CoachSportQualificationFormData = z.infer<typeof coachSportQualificationSchema>;
